import { createContext } from "react";
import type { ContentsItem } from "../WithPublication/PublicationContext";
import type { PostOrPage } from "@tryghost/content-api";

export type GhostPost = {
  tags?: PostOrPage["tags"];
  authors?: PostOrPage["authors"];
  publishedAt?: string | null;
  featureImage?: string | null;
  featureImageAlt?: string | null;
  relatedPosts?: Array<{
    title: string | null;
    slug: string;
    publishedAt: string | null;
    excerpt: string | null;
    authors: Array<{ name: string | null }>;
  }>;
  nextPost?: {
    title: string | null;
    slug: string;
    publishedAt: string | null;
    authors: Array<{ name: string | null }>;
  } | null;
  issueName?: string | null;
  issueArticles?: Array<{
    title: string | null;
    slug: string;
    publishedAt: string | null;
    authors: Array<{ name: string | null }>;
  }>;
};

type ArticleContextType = {
  contents?: ContentsItem[];
  setContents: React.Dispatch<React.SetStateAction<ContentsItem[] | undefined>>;
  styles?: string;
  chapters?: Record<string, string>;
  htmlChunks?: Record<number, string>;
  articleSlug?: string;
  title?: string | null;
  currentSection?: ContentsItem;
  selectSection: (
    id: string,
    section?: ContentsItem,
    noScroll?: boolean,
  ) => void;
  currentChunk?: string;
  selectByHash: (hash: string) => void;
  scrollDisabled?: boolean;
  setScrollDisabled: (disable: boolean) => void;
  scrollSnippet?: string;
  setScrollSnippet: (snippet: string | undefined) => void;
  pendingHash?: string;
  setPendingHash: (hash: string | undefined) => void;
  containerRef: React.RefObject<HTMLDivElement | null>;
  ghostPost?: GhostPost | null;
};

export const ArticleContext = createContext<ArticleContextType>({
  contents: undefined,
  setContents: () => {},
  styles: undefined,
  chapters: undefined,
  htmlChunks: undefined,
  articleSlug: undefined,
  title: undefined,
  currentSection: undefined,
  selectByHash: () => {},
  selectSection: () => {},
  currentChunk: undefined,
  scrollDisabled: undefined,
  setScrollDisabled: () => {},
  scrollSnippet: undefined,
  setScrollSnippet: () => {},
  setPendingHash: () => {},
  containerRef: { current: null },
});
